import Container from '@mui/material/Container';
import { BulkMembers } from '../../features/team';
import { PAGES_ANALYTICS_TITLES } from '../../utils/enums';
import { PageHelmet } from '../../components';

const BulkMembersPage = () => (
  <PageHelmet title={PAGES_ANALYTICS_TITLES.BULK_MEMBERS}>
    <Container
      sx={{
        px: {
          xs: 0, lg: 2, md: 2, sm: 2,
        },
      }}
      maxWidth={false}
    >
      <BulkMembers />
    </Container>
  </PageHelmet>
);

export default BulkMembersPage;
